import EA from '../helpers/init';

export default EA.Methods.animFadeUp = ($this) => {
    const fadeElements = $this.querySelectorAll('.fade-in');

    const animateGroup = (elements) => {
        const groups = new Map();

        elements.forEach(el => {
            const top = Math.round(el.getBoundingClientRect().top / 10) * 10;
            if (!groups.has(top)) groups.set(top, []);
            groups.get(top).push(el);
        });

        groups.forEach(group => {
            group.forEach((el, index) => {
                setTimeout(() => {
                    el.classList.add('show');
                }, index * 150); // 150ms between each item in the row
            });
        });
    };

    const observer = new IntersectionObserver((entries) => {
        const intersecting = entries.filter(entry => entry.isIntersecting).map(entry => entry.target);

        if(intersecting.length) {
            animateGroup(intersecting);
            intersecting.forEach(el => observer.unobserve(el));
        }
    }, {
        threshold: 0.2
    });

    fadeElements.forEach(el => observer.observe(el));
};
